import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 28, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-90px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Signature masked line-by-line reveal for large serif headlines.
export const MaskedLines = ({ lines, className = "", animate = false, delay = 0.15 }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.14, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "112%" },
    show: { y: 0, transition: { duration: 1.15, ease: [0.76, 0, 0.24, 1] } },
  };
  return (
    <motion.h1
      className={className}
      variants={container}
      initial="hidden"
      {...(animate ? { animate: "show" } : { whileInView: "show", viewport: { once: true, margin: "-90px" } })}
    >
      {lines.map((content, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span variants={line} className="block">
            {content}
          </motion.span>
        </span>
      ))}
    </motion.h1>
  );
};
